import moment from 'moment'

const ACCESS_TOKEN_KEY = 'app_access_token'
const REFRESH_TOKEN_KEY = 'app_refresh_token'
const EXPIRED_TOKEN = 'app_expired_at'

export const getAccessToken = () => {
  let accessToken = window.localStorage.getItem(ACCESS_TOKEN_KEY)
  // Check exists token
  if (!accessToken) {
    return null
  }

  let expiredToken = window.localStorage.getItem(EXPIRED_TOKEN)
  // Check expired token
  if ((moment().unix() - parseInt(expiredToken)) > 0) {
    return null
  }

  return accessToken
}

export const getRefreshToken = () => {
  return window.localStorage.getItem(REFRESH_TOKEN_KEY)
}

export const setRefreshToken = (refresh_token) => {
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token)
}

export const setAccessToken = (access_token, expire_at) => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, access_token)

  // let now = moment().add(parseInt(expire_at), 's')
  // window.localStorage.setItem(EXPIRED_TOKEN, now.unix())
  window.localStorage.setItem(EXPIRED_TOKEN, expire_at)
}

export const destroyToken = () => {
  window.localStorage.removeItem(ACCESS_TOKEN_KEY)
  window.localStorage.removeItem(REFRESH_TOKEN_KEY)
  window.localStorage.removeItem(EXPIRED_TOKEN)
}

export default { getAccessToken, getRefreshToken, setRefreshToken, setAccessToken, destroyToken }